module.exports = __webpack_public_path__ + "static/hifi10-4cf9aff9b48d748d8d2cad193c24f443.jpg";